/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ViewStyle {
  List = 'List',
  Tiles = 'Tiles',
  Kanban = 'Kanban',
  Split = 'Split'
}
